<div class="product-tag-wrapper" *ngIf="product">
    <div class="bg-summer-light product-tag" *ngIf="product.novelty">
        {{ 'productItem.novelty' | cxTranslate }}
    </div>
    <div class="bg-yellow product-tag" *ngIf="product.campaign">
        {{ 'productItem.campaign' | cxTranslate }}
    </div>
    <div class="bg-autumn-light product-tag" *ngIf="product.sponsored">
        {{ 'productItem.sponsored' | cxTranslate }}
    </div>
</div>
